export const OPERATOR_APPLICATION_RELOAD_DATA_EVENT = "reloadData";
export const OPERATOR_APPLICATION_LOAD_DELAYED_MESSAGES_EVENT = "loadDelayedMessages";